/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const BlogPostsModifier = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 * @param {jQuery} $blogIconContainer
	 * @param {jQuery} $filterContainer
	 * @param {string} twitterSvg
	 * @param {string} facebookSvg
	 * @param {string} instagramSvg
	 * @param {string} linkedinSvg
	 * @param {object} observer
	 */
	$blogIconContainer: {},
	$blogContainer: $('#manage-ajax-response'),
	$filterContainer: $('#caf-filter-layout1'),
	interval: {},
	twitterSvg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="currentColor"><g clip-path="url(#clip0_2597_1681)"><path d="M8.332 5.925L13.544 0h-1.235L7.783 5.145 4.17 0H0l5.466 7.78L0 13.993h1.235l4.78-5.433 3.816 5.433H14L8.332 5.925zM6.64 7.848l-.554-.775L1.68.91h1.897l3.556 4.975.554.775 4.622 6.466h-1.897L6.64 7.848z"/></g><defs><clipPath id="clip0_2597_1681"><path d="M0 0h14v14H0z"/></clipPath></defs></svg>',
	facebookSvg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 15" fill="currentColor"><g clip-path="url(#clip0_59_431)"><path d="M8.723 8.438l.445-2.715H6.389V3.96c0-.742.388-1.466 1.633-1.466h1.263V.183S8.138 0 7.043 0C4.754 0 3.259 1.3 3.259 3.654v2.069H.715v2.715H3.26V15h3.13V8.437h2.334z"/></g><defs><clipPath id="clip0_59_431"><path d="M0 0h10v15H0z"/></clipPath></defs></svg>',
	instagramSvg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="currentColor"><g clip-path="url(#clip0_2597_1683)"><path d="M7.004 4.682c-1.988 0-3.591 1.703-3.591 3.815 0 2.111 1.603 3.815 3.59 3.815 1.988 0 3.591-1.704 3.591-3.815 0-2.112-1.603-3.815-3.59-3.815zm0 6.295c-1.285 0-2.335-1.112-2.335-2.48 0-1.368 1.047-2.48 2.335-2.48 1.287 0 2.334 1.112 2.334 2.48 0 1.368-1.05 2.48-2.334 2.48zm4.575-6.451c0 .494-.376.89-.838.89-.466 0-.837-.4-.837-.89 0-.492.374-.89.837-.89.463 0 .838.398.838.89zm2.378.903c-.054-1.192-.31-2.248-1.132-3.118-.818-.87-1.812-1.142-2.934-1.202-1.156-.07-4.622-.07-5.778 0-1.119.056-2.113.329-2.934 1.199C.357 3.178.104 4.233.047 5.425c-.065 1.229-.065 4.911 0 6.14.053 1.192.31 2.248 1.132 3.117.821.87 1.812 1.143 2.934 1.202 1.156.07 4.622.07 5.778 0 1.122-.056 2.116-.328 2.934-1.202.82-.87 1.075-1.925 1.132-3.117.065-1.229.065-4.908 0-6.136zm-1.494 7.454a2.442 2.442 0 01-1.331 1.414c-.922.389-3.11.299-4.128.299-1.02 0-3.21.086-4.129-.299a2.438 2.438 0 01-1.33-1.414c-.366-.98-.282-3.304-.282-4.386 0-1.083-.081-3.41.281-4.386a2.442 2.442 0 011.331-1.415c.922-.388 3.11-.299 4.129-.299 1.018 0 3.209-.086 4.128.299.612.259 1.084.76 1.33 1.414.367.98.282 3.304.282 4.387 0 1.082.085 3.41-.281 4.386z"/></g><defs><clipPath id="clip0_2597_1683"><path d="M0 0h14v17H0z"/></clipPath></defs></svg>',
	linkedinSvg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" fill="currentColor"><path d="M3.134 14H.23V4.653h2.903V14zM1.68 3.378C.753 3.378 0 2.61 0 1.681a1.68 1.68 0 113.362 0c0 .929-.753 1.697-1.681 1.697zM13.997 14H11.1V9.45c0-1.084-.022-2.475-1.51-2.475-1.508 0-1.74 1.178-1.74 2.397V14h-2.9V4.653h2.785v1.275h.04c.388-.734 1.334-1.51 2.747-1.51C13.46 4.419 14 6.354 14 8.867V14h-.003z"/></svg>',
	observer: {},

	/**
	 * @description waits for
	 */
	init: function() {
		const _this = this;
		$(document).ready(function() {
			if (_this.$blogContainer.length) {
				_this.appendCategoryName();
				_this.interval = setInterval(function() {
					_this.$blogIconContainer = $('.caf-content-read-more');
					if (_this.$blogIconContainer.length) {
						_this.appendSocialIcons();
						_this.removeUnusedContent();
						_this.appendTitle();
					}
				}, 500);
			}
		});
	},

	/**
	 * @description appends category name to blog URL
	 */
	appendCategoryName: function() {
		const _this = this;
		_this.$blogContainer.on('click', 'a', function(e) {
			let link = $(this).attr('href');
			const currentUrl = window.location.host;
			if (link.includes(currentUrl)) {
				e.preventDefault();
				const activePill = _this.$filterContainer.find('a.active');
				const categoryName = activePill.text();
				if (activePill.length && categoryName && categoryName.toLowerCase() !== 'all topics') {
					link += '?category=' + encodeURIComponent(categoryName);
				}

				window.location.href = link;
			}
		});
	},

	/**
	 * @description appends title to blog container
	 */
	appendTitle: function() {
		$('.section-title').remove();
		const activePill = this.$filterContainer.find('a.active');
		const categoryName = activePill.length ? activePill.text().replace(/(<([^>]+)>)/ig, '') : 'All Topics';
		this.$blogContainer.before(`<h2 class="section-title blog-cards__section-title">${categoryName}</h2>`);
	},

	/**
	 * @description appends Twitter and Facebook SVGs to blog cards
	 */
	appendSocialIcons: function() {
		const _this = this;
		if (this.interval) {
			clearInterval(this.interval);
			this.interval = null;
			this.addAjaxListener();
		}

		$('.caf-post-layout1').each(function(i, element) {
			// get href
			let blogHref = $(element).find('.caf-read-more').first().attr('href');
			blogHref = blogHref !== undefined ? encodeURIComponent(blogHref) : '#';

			// get title
			let blogTitle = $(element).find('.caf-post-title').first().text();
			blogTitle = blogTitle ? encodeURIComponent(blogTitle) : '';

			// form urls
			const facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + blogHref;
			const twitterLink = 'https://twitter.com/share?url=' + blogHref + '&text=' + blogTitle;
			const linkedinLink = 'https://www.linkedin.com/sharing/share-offsite/?url=' + blogHref;

			// prepare html content
			const htmlContent = `
				<ul class="blog-cards__footer-social-media">
					<li>
						<a class="social-blog-link" href="${linkedinLink}" target="_blank" rel="noopener" aria-label="Facebook Link">
							${_this.linkedinSvg}
						</a>
					</li>
					<li>
						<a class="social-blog-link" href="${facebookLink}" target="_blank" rel="noopener" aria-label="Twitter Link">
							${_this.facebookSvg}
						</a>
					</li>
					<li>
						<a class="social-blog-link" href="${twitterLink}" target="_blank" rel="noopener" aria-label="Twitter Link">
							${_this.twitterSvg}
						</a>
					</li>
				</ul>`;

			// append
			const readMore = $(this).find('.caf-content-read-more');
			if (readMore.length > 0) {
				readMore.append(htmlContent);
			}
		});

		this.addSocialIconEventListener();

		this.$filterContainer.find('a').each((index, element) => {
			if($(element).text().toLowerCase() === 'uncategorized') {
				$(element).parent().remove();
			}

			if($(element).text().toLowerCase() === 'all') {
				$(element).text('All Topics');
			}
		});
	},

	/**
	 * @description fix link not opening up in new tab
	 */
	addSocialIconEventListener: function() {
		$('.social-blog-link').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			window.open($(this).attr('href'), '_blank').focus();
		});
	},

	/**
	 * @description removes unused content which plugin creates
	 */
	removeUnusedContent: function() {
		$('.caf-meta-content').remove();
	},

	/**
	 * @description Listens to class changes on blog holder container,
	 * removing unused content and appending social icons on successful ajax calls
	 */
	addAjaxListener: function() {
		const _this = this;
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				const attributeValue = $(mutation.target).prop(mutation.attributeName);
				if (!attributeValue.includes('loading')) {
					_this.appendSocialIcons();
					_this.removeUnusedContent();
					_this.scrollToTop();
					_this.appendTitle();
				}
			});
		});

		if (this.$blogContainer.length) {
			observer.observe(this.$blogContainer[0], {
				attributes: true,
				attributeFilter: ['class'],
			});
		}
	},

	/**
	 * @description Scroll blog section into view on page change
	 */
	scrollToTop: function() {
		if (this.$filterContainer.length > 0) {
			$([document.documentElement, document.body]).scrollTop(this.$filterContainer.offset().top - 70);
		}
	}
};

export default BlogPostsModifier;
